import { render, staticRenderFns } from "./EstudanteForm.vue?vue&type=template&id=2200716a"
import script from "./EstudanteForm.vue?vue&type=script&lang=js"
export * from "./EstudanteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports